import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { RULESMESSAGE } from '../../_constants';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { addSubUserAction } from '../../actions/Subuser';
import { notification } from 'antd';
import loadingImage from "../loadingImageRc.gif";

let className = "";
let Validator = require('validatorjs');
let styleData = { color: "red" }
let formArr = {};
let rules = {
    firstName: 'required',
    email: 'required|email',
};
let validation = [];
validation = new Validator([], rules, RULESMESSAGE);
validation.passes();
validation.fails();
class SubUserAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            subUserForm: {
                firstName: "",
                email: ""
            },
            requestServer: false,
            fieldsList: [],
            formArr: {},
        };
        this.addSubUser = this.addSubUser.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        switch (nextProps.responseType) {
            case "add":
                let _this = this;
                notification.success({
                    message: nextProps.response.msg,
                    className:'successNotification',
                    duration: 3
                });
                this.setState({
                    requestServer: false
                })
                break;
            case "error":
                notification.error({
                    message: nextProps.responseErr.msg,
                    className:'errorNotification',
                    duration: 3
                });
                this.setState({
                    requestServer: false
                })
                break;
            default:
                return true;
        }
    }

    handleChange = e => {
        e.preventDefault();
        let { subUserForm } = this.state;
        subUserForm[e.target.name] = e.target.value;
        this.setState({ subUserForm });
    };

    addSubUser() {
        if (this.allValidate(false)) {
            let subUserForm = this.state.subUserForm;
            //subUserForm.typeMail = "live" ;
            //subUserForm.typeMail = "local" ;
            subUserForm.typeMail = "stage";
            // this.setState({
            // requestServer: true
            // })
            this.props.addSubUserAction(subUserForm)
        }
    }

    allValidate(check) {
        if (!check) {
            formArr = []
            Object.keys(rules).forEach(function(key) {
                formArr[key] = "TT";
            });
            this.setState({
                formArr
            });
        }
        if (validation.passes()) {
            return 1;
        }
    }
    render() {

        const { action, isOpen } = this.props
        const { requestServer, subUserForm } = this.state;
        validation = new Validator(subUserForm, rules, RULESMESSAGE);
        validation.passes();
        validation.fails();
        if (requestServer) {
            className = "pageloading";
        } else {
            className = "";
        }

        return (
            <div className="row">
                <div className={"pageForLoading "+className}>
                    <div className=" wrap">
                        <div className="loading">
                            <img src={loadingImage} alt="Loading" />
                        </div>
                    </div>
                </div>
                <Modal backdrop="static" keyboard={false} isOpen={isOpen} toggle={action} className="detail-modal modal-lg">
                    <ModalHeader toggle={action}>Add User</ModalHeader>
                    <ModalBody className="spc-radi">
                        <div className="user-section">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label className="pf-label">Name<span>*</span></label>
                                        <input type="text" className="form-control singup-control" name="firstName" onChange={this.handleChange} placeholder="Name" value={subUserForm.firstName} />
                                        <span style={styleData} className="error">{this.state.formArr.firstName && validation.errors.first('firstName')}</span>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label className="pf-label">Email<span>*</span></label>
                                        <input type="email" className="form-control singup-control" name="email" onChange={this.handleChange} placeholder="Email" value={subUserForm.email} />
                                        <span style={styleData} className="error">{this.state.formArr.email && validation.errors.first('email')}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="button-block">
                                    <button className="cancel-btn pull-right" onClick={action}>Cancel</button>
                                    <button className="save-btn update-btn pull-right" onClick={this.addSubUser}>Update</button>
                                </div>
                            </div>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        responseType: state.SubUser.type,
        response: state.SubUser.response,
        responseErr: state.SubUser.responseErr,
    };
}
export default withRouter(connect(mapStateToProps, {
    addSubUserAction
})(SubUserAdd));


// WEBPACK FOOTER //
// ./src/components/SubUser/SubUserAdd.js